import './../app/shared/operators';
import { of } from 'rxjs/observable/of';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Action } from '@ngrx/store';
import { Effect, Actions } from '@ngrx/effects';

import * as c from '../actions/company.actions';

import { Api } from '../providers/api/api';

@Injectable()
export class CompanyEffects {
  constructor(private actions$: Actions,
    private api: Api
  ) {
  }

  @Effect()
  loadCompanyByTicker$: Observable<Action> = this.actions$
    .ofType(c.FETCH_COMPANY)
    .map((action: c.FetchCompany) => {
      return action.payload;
    })
    .switchMap((ticker) => this.api.getCompanyByTicker(ticker))
    .map(company => {
      return new c.FetchCompanySuccess(company)
    }
    ).catch((err) => of(new c.FetchCompanyFailure(err)));

}



// WEBPACK FOOTER //
// ./src/effects/company.effect.ts